import axios from "axios";

export async function getGroups() {
    const configuration = {
        url: process.env.SERVER + 'group/list',
        method: 'get',
        headers: { token: `${sessionStorage.getItem('restoken')}` },
    };
    try { const response = await axios(configuration); return response.data; }
    catch (error) { throw error }
}

export async function getGroupById(id) {
    const configuration = {
        url: process.env.SERVER + `group/${id}`,
        method: 'get',
        headers: { token: `${sessionStorage.getItem('restoken')}` },
    };
    try { const response = await axios(configuration); return response.data; }
    catch (error) { throw error }
}

export async function addGroup(data) {
    const configuration = {
        url: process.env.SERVER + 'group/',
        headers: { token: `${sessionStorage.getItem('restoken')}` },
        method: 'post',
        data: data
    };
    try { const response = await axios(configuration); return response.data; }
    catch (error) { throw error }
}

export async function editGroup(id, data) {
    const configuration = {
        url: process.env.SERVER + `group/${id}`,
        headers: { token: `${sessionStorage.getItem('restoken')}` },
        method: 'put',
        data: data
    };
    try { const response = await axios(configuration); return response.data; }
    catch (error) { throw error }
}

export async function delGroup(id) {
    const configuration = {
        url: process.env.SERVER + `group/${id}`,
        headers: { token: `${sessionStorage.getItem('restoken')}` },
        method: 'delete'
    };
    try { const response = await axios(configuration); return response.data; }
    catch (error) { throw error }
}